import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';
import Card from '../../components/Cards/Card';
import useDocTitle from '../../utils/useDocTitle';
import SideMenu from '../../components/SideMenu';
import axios from 'axios';
import { useLanguage } from '../../context/LanguageContext';

const TalkReadings = () => {
  const { language } = useLanguage(); // Use language context for translations
  useDocTitle(language === 'English' ? 'Talks and Readings' : 'Bisedat dhe Seancat Leximore');

  const [talks, setTalks] = useState([]);
  const [mainPageData, setMainPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  const menuItems = [
    //{ href: '#overview', label: language === 'English' ? 'Overview' : 'Përmbledhje' },
    { href: '#talksAndReadings', label: language === 'English' ? 'Talks and Readings' : 'Bisedat dhe Seancat Leximore' },
  ];

  // Fetch Talks and Main Page Data
  useEffect(() => {
    const fetchTalksAndMainPage = async () => {
      try {
        const [talksResponse, mainPageResponse] = await Promise.all([
          axios.get('https://annexpilot.com/dashboard/wp-json/wp/v2/talks_readings'),
          axios.get('https://annexpilot.com/dashboard/wp-json/wp/v2/tlk_read_mainpage'),
        ]);

        const filteredTalks = talksResponse.data.filter((talk) => talk.page_language[0].name === language);
        setTalks(filteredTalks);

        const mainPage = mainPageResponse.data.find((page) => page.page_language[0].name === language);
        if (mainPage) {
          setMainPageData({
            title: mainPage.title.rendered,
            mainTitle: mainPage.main_title,
            mainText: mainPage.main_text,
            backgroundImage: mainPage.main_image.guid,
            backgroundImageAlt: mainPage.main_image.post_excerpt
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTalksAndMainPage();
  }, [language]);

  if (loading) {
    return <div>{language === 'English' ? 'Loading...' : 'Duke u ngarkuar...'}</div>;
  }

  return (
    <>
      <NavBar />

      {/* Hero Section */}
      {mainPageData && (
        <div
          className="relative w-full h-96 bg-cover bg-center flex items-center justify-center"
          style={{
            backgroundImage: `url(${mainPageData.backgroundImage})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            height: '550px',
          }}
          role="img"
          alt = {mainPageData.backgroundImageAlt}
          aria-label={
            mainPageData.title ||
            (language === 'English'
              ? 'Banner image for Talks and Readings'
              : 'Foto baneri per Bisedat dhe Seancat Leximore')
          }
        >
          <div className="absolute inset-0 bg-black opacity-60" aria-hidden="true"></div>
          <div className="relative z-10 text-center text-white">
            <h1 className="text-5xl font-bold" tabIndex="0">
              {mainPageData.title}
            </h1>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex flex-col lg:flex-row min-h-screen">
        {/* Side Menu */}
        <aside
          className="lg:w-1/4 bg-gray-100 px-4 lg:px-8 py-6 lg:py-12 sticky top-16 lg:h-screen"
          aria-label={
            language === 'English'
              ? 'Sidebar navigation for Talks and Reading Sessions'
              : 'Navigim anësor për Bisedat dhe Seancat Leximore'
          }
        >
          <SideMenu
            backLink="/educational-program"
            backText={language === 'English' ? 'EDUCATIONAL PROGRAMS' : 'PROGRAMET EDUKATIVE'}
            menuItems={menuItems}
          />
        </aside>

        {/* Main Section */}
        <div className="w-full lg:w-3/4 py-8 px-4 lg:px-6">
          {/* Overview Section */}
          {mainPageData && (
            <section id="overview" className="container-inner mb-12">
              <h2 className="text-3xl font-semibold mb-6" tabIndex="0">
                {mainPageData.mainTitle}
              </h2>
              <div
                className="text-lg text-gray-600 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: mainPageData.mainText }}
              ></div>
            </section>
          )}

          {/* Talks and Readings Section */}
          <section id="talksAndReadings" className="container-inner mb-12">
            <h2 className="text-3xl font-semibold mb-6" tabIndex="0">
              {language === 'English' ? 'Talks and Readings' : 'Bisedat dhe Seancat Leximore'}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
              {talks.map((talk) => (
                <Card
                  key={talk.id}
                  id={talk.id}
                  title={talk.title.rendered}
                  description={talk.description || talk.content_description}
                  imgSrc={talk.card_image.guid}
                  imgAlt={talk.card_image.post_excerpt}
                  linkText={language === 'English' ? 'Learn More' : 'Mëso më shumë'}
                  linkPath={`/resources/talks-reading/${talk.id}`}
                  borderColorClass="border-secondary"
                  ariaLabel={
                    language === 'English'
                      ? `Learn more about ${talk.title.rendered}`
                      : `Mëso më shumë rreth ${talk.title.rendered}`
                  }
                />
              ))}
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TalkReadings;